export default "__VITE_ASSET__2TAo2XWP__"